import React, { Component } from "react";
import TutorTabla from "./TutorTabla";
import { connect } from "react-redux";
import { getTutorList } from './TutorAction'
import { withRouter } from 'react-router-dom';

class TutorContainer extends Component {

    componentDidMount() {
        //console.log("TutorContainer");
        this.props.dispatch(getTutorList());
    }

    render() {
        return (
            <div>
                <TutorTabla />
            </div>
        );
    }
}

export default connect()(TutorContainer);
